module.exports = __webpack_public_path__ + "img/0xa8c51aa0c177187aeed3db88bdfa908ccbc9b1a5.e1e5d8ce.png";